import { D, money, sum } from './money';
import type { JournalEntry, JournalLine } from './types';

export class Ledger {
  private readonly entries: JournalEntry[] = [];
  private readonly balances = new Map<string, ReturnType<typeof D>>();

  post(entry: JournalEntry): { ok: true } | { ok: false; kind: 'UNBALANCED'|'INVALID_LINE' } {
    if (entry.lines.some(l => (!l.debit.isZero() && !l.credit.isZero()) || l.debit.isNegative() || l.credit.isNegative())) return { ok: false, kind: 'INVALID_LINE' };
    const debit = money(sum(entry.lines.map(l => l.debit)));
    const credit = money(sum(entry.lines.map(l => l.credit)));
    if (!debit.equals(credit)) return { ok: false, kind: 'UNBALANCED' };
    entry.lines.forEach(line => this.apply(line));
    this.entries.push(entry);
    return { ok: true };
  }
  private apply(line: JournalLine) {
    const normalDebit = /^(CASH|LOAN|SOVEREIGN|MORTGAGE|RETAIL|DISTRESSED|EXPENSE|IMPAIRMENT)/.test(line.account);
    const delta = normalDebit ? line.debit.minus(line.credit) : line.credit.minus(line.debit);
    this.balances.set(line.account, money((this.balances.get(line.account) ?? D(0)).plus(delta)));
  }
  balance(account: string) { return this.balances.get(account) ?? D(0); }
  allEntries() { return [...this.entries]; }
}

export const line = (account: string, debit: number | string = 0, credit: number | string = 0): JournalLine =>
  ({ account, debit: money(debit), credit: money(credit) });
